import createClient from 'openapi-fetch';
import type { paths } from '../../types/authSchema';
import baseUrl from '@pocapan/shared/utils/baseUrl';

export const authApiClient = createClient<paths>({ baseUrl: baseUrl() });

function asRecord(value: unknown): Record<string, unknown> | null {
  if (!value || typeof value !== 'object') return null;
  return value as Record<string, unknown>;
}

function findStringValue(target: Record<string, unknown>, key: string): string | null {
  const value = target[key];
  if (typeof value === 'string' && value.trim() !== '') {
    return value;
  }
  return null;
}

export function resolveAuthApiErrorMessage(error: unknown, fallbackMessage: string): string {
  const record = asRecord(error);
  if (!record) return fallbackMessage;

  const topLevelMessage = findStringValue(record, 'message');
  if (topLevelMessage) return topLevelMessage;

  const nestedError = asRecord(record.error);
  if (!nestedError) return fallbackMessage;

  return (
    findStringValue(nestedError, 'message') ||
    findStringValue(nestedError, 'detail') ||
    findStringValue(nestedError, 'errorMessage') ||
    fallbackMessage
  );
}
